export enum Sign {
    PESO = '$',
    EURO = 'Є',
    PERCENTAGE = '%'
}